<template>
    <div>
        <v-col cols="12">
            <h2 class="mt-4 mb-0">{{ t('quality-control::page.title.quality-control') }}</h2>
            <quality-control-devices-data-table
                :list-route="listRoute"
                :initial-filters="initialFilters"
            ></quality-control-devices-data-table>
        </v-col>
    </div>
</template>

<script>
export default {
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            initialFilters: {
                visible_in_qc_list: 1,
                is_patient_mode: null,
            },
        };
    },
};
</script>
